import { Container, Grid, List, ListItem, ListItemIcon, ListItemText, makeStyles } from '@material-ui/core';
import { vungSubMenus, VUNG_PACKAGE } from 'components/app-navigator/navMenus';
import React from 'react';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    wrapper: {
        minHeight: 'calc(100vh - 56px)',
        display: 'flex',
        paddingTop: '10%',
    },
    container: {
        height: '100%',
    },
    root: {
        flexGrow: 1,
    },
    paper: {
        minHeight: 300,
        minWidth: 300,
        padding: theme.spacing(3),
    },
    listHeader: {
        fontSize: 24,
        fontWeight: 'bold',
    },
}));

function VungPage() {
    const classes = useStyles();
    const history = useHistory();
    const paymentItems = vungSubMenus.filter((item) => item.package === VUNG_PACKAGE.PAYMENT);
    const reportItems = vungSubMenus.filter((item) => item.package === VUNG_PACKAGE.REPORT);

    return (
        <div className={classes.wrapper}>
            <Container maxWidth="md" className={classes.container}>
                <div className={classes.root}>
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <List component="nav" aria-labelledby="nested-list-subheader" className={classes.root}>
                                        <ListItem className={classes.listHeader}>{VUNG_PACKAGE.PAYMENT}</ListItem>
                                        {paymentItems.map((menu, index) => (
                                            <ListItem button onClick={() => history.push(menu.path)} key={index}>
                                                <ListItemIcon>{menu.icon}</ListItemIcon>
                                                <ListItemText primary={menu.title} />
                                            </ListItem>
                                        ))}
                                    </List>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={6}>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <List component="nav" aria-labelledby="nested-list-subheader" className={classes.root}>
                                        <ListItem className={classes.listHeader}>{VUNG_PACKAGE.REPORT}</ListItem>
                                        {reportItems.map((menu, index) => (
                                            <ListItem button onClick={() => history.push(menu.path)} key={index}>
                                                <ListItemIcon>{menu.icon}</ListItemIcon>
                                                <ListItemText primary={menu.title} />
                                            </ListItem>
                                        ))}
                                    </List>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
            </Container>
        </div>
    );
}

export default VungPage;
